export default __webpack_public_path__ + "static/media/seller_debit_note.9020bdfd.xlsx";